import actions from 'netxcore@netx/core-cms/actions';
import {extendBackboneActions} from '@netx/core/utils/extendBackboneActions';

import categoryConfig from '@netx/core-category/config';

// Extend actions defined in core file
let newActions = extendBackboneActions(actions, [
	/** @action */
	{
		event: 'cms:route:category:root',
		label: i18n.t('i18n.assets'),
		enableTest(view) {
			return categoryConfig.categoryid > 0;
		},
	},
]);

// New actions
newActions = newActions.concat([
	/** @action */
	{
		event: 'cms:page:home:route',
		label: 'Home',
		route: 'page/home',
	},
	/** @action */
	{
		event: 'cms:cart:route',
		label: i18n.t('i18n.selection'),
		route: 'cart',
	},
	/** @action */
	{
		event: 'cms:saved-carts:route',
		label: i18n.t('i18n.collections'),
		route: 'cart/saved',
	},
]);

export default newActions;
